import { createContext, useContext, useState, ReactNode, useEffect } from 'react';
import authService from '../services/authService';

export type AuthDialogMode = 'login' | 'register' | 'restore' | 'register-choice' | 'legal-entity';

interface AuthDialogContextType {
  isAuthDialogOpen: boolean;
  authDialogMode: AuthDialogMode;
  openAuthDialog: (mode?: AuthDialogMode) => void;
  closeAuthDialog: () => void;
  switchAuthMode: (mode: AuthDialogMode) => void;
}

const AuthDialogContext = createContext<AuthDialogContextType | undefined>(undefined);

export function AuthDialogProvider({ children }: { children: ReactNode }) {
  const [isAuthDialogOpen, setIsAuthDialogOpen] = useState(false);
  const [authDialogMode, setAuthDialogMode] = useState<AuthDialogMode>('login');

  const openAuthDialog = (mode: AuthDialogMode = 'login') => {
    setAuthDialogMode(mode);
    setIsAuthDialogOpen(true);
  };

  const closeAuthDialog = () => {
    setIsAuthDialogOpen(false);
  };

  const switchAuthMode = (mode: AuthDialogMode) => {
    setAuthDialogMode(mode);
  };

  // Регистрируем callback в AuthService
  useEffect(() => {
    authService.setAuthDialogCallback(openAuthDialog);
  }, []);

  return (
    <AuthDialogContext.Provider value={{ 
      isAuthDialogOpen, 
      authDialogMode, 
      openAuthDialog, 
      closeAuthDialog, 
      switchAuthMode 
    }}>
      {children}
    </AuthDialogContext.Provider>
  );
}

export function useAuthDialog() {
  const context = useContext(AuthDialogContext);
  if (context === undefined) {
    throw new Error('useAuthDialog must be used within an AuthDialogProvider');
  }
  return context;
}
